import { Controller } from "@hotwired/stimulus";

// Add the "clicked" class when the target is clicked
// See click_swap.css for an example of how this can
// be used.
export default class extends Controller {
  static targets = ["clickable"];

  connect() {
    if (this.hasClickableTarget) {
      this.boundClick = () => {
        this.element.classList.add("clicked");
      };
      this.clickableTarget.addEventListener("click", this.boundClick);
    }
  }

  disconnect() {
    if (this.boundClick && this.hasClickableTarget) {
      this.clickableTarget.removeEventListener("click", this.boundClick);
    }
  }
}
